import { useCallback, useContext } from 'react';
import { updateNotification } from 'src/api/notifications';
import { NotificationContext } from 'src/contexts/notification-context-types';
import { Notification, NotificationUpdateBody } from 'src/models/notification';
import { usePopup } from './use-popup';

export const useNotificationContext = () => {
  const context = useContext(NotificationContext);
  const { setError } = usePopup();
  if (!context) throw new Error('useAuthContext context must be used inside NotificationProvider');

  const { notifications, setNotifications, socket } = context;

  const editNotificationHandler = useCallback(
    async (updatedData: Partial<NotificationUpdateBody>) => {
      const res = await updateNotification(updatedData);

      if (res.success) {
        setNotifications((prev: Notification[]) => {
          const updatedNotification = res.data;
          return prev.map((notification: Notification) => {
            const data = updatedNotification.find((updated) => updated._id === notification._id);
            return data ? { ...notification, ...data } : notification;
          });
        });
        return true;
      } else {
        setError(res.error ?? 'Failed to update notification');
        return false;
      }
    },
    [setNotifications, setError] // ← no notifications dependency
  );

  // const clearAllNotifications = useCallback(async () => {
  //   const res = await clearNotifications();
  //   if(res.success){
  //      setNotifications(() => []);
  //   } else{
  //     setError(res.error ?? 'Failed to clear notifications')
  //   }
  // }, [setNotifications, setError])

  return {
    notifications,
    editNotificationHandler,
    // clearAllNotifications,
    socket,
  };
};